import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useQuery } from 'src/Hooks/useQuery'
import { ProgressBarSteps } from 'src/Libs/shop/types'
import { SYSTEM_CONFIGURE_PROGRESS_PAGE_PARAM } from 'src/Libs/shop/consts'
import { QntmSystemConfigurationContext } from '../context/use-shop-qntm-system-configuration-context'

interface QntmSystemConfigurationProviderProps {
  children: React.ReactNode
}
/*
 * Provides state and navigation logic for system configuration steps
 */
export const QntmSystemConfigurationProvider: React.FC<QntmSystemConfigurationProviderProps> = ({ children }) => {
  const query = useQuery()
  const navigate = useNavigate()
  const location = useLocation()

  const [activePage, setActivePage] = useState<number>(Number(query.get(SYSTEM_CONFIGURE_PROGRESS_PAGE_PARAM)) || ProgressBarSteps.BasicSystem)
  const [allowContinueMain, setAllowContinueMain] = useState<boolean>(false)

  const currentPage = query.get(SYSTEM_CONFIGURE_PROGRESS_PAGE_PARAM)

  const handleProgress = useCallback(
    (progress: ProgressBarSteps): void => {
      setActivePage(progress)
      navigate(location.pathname + `?${SYSTEM_CONFIGURE_PROGRESS_PAGE_PARAM}=${progress}`, { replace: true })
    },
    [navigate, location.pathname]
  )

  useEffect(() => {
    setActivePage(Number(currentPage) || ProgressBarSteps.BasicSystem)
  }, [currentPage])

  useEffect(() => {
    if (!currentPage) {
      navigate(location.pathname + `?${SYSTEM_CONFIGURE_PROGRESS_PAGE_PARAM}=${ProgressBarSteps.BasicSystem}`, { replace: true })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage])

  const contextValue = useMemo(
    () => ({
      activePage,
      setActivePage,
      handleProgress,
      allowContinueMain,
      setAllowContinueMain,
    }),
    [activePage, allowContinueMain, handleProgress]
  )

  return <QntmSystemConfigurationContext.Provider value={contextValue}>{children}</QntmSystemConfigurationContext.Provider>
}
